@if (loading) {
	<skeletons [defaultSkeletons]="5" />
}
@else {
	<list-view scrollable #orderList emptyLabel="sale.orders-list.empty">
		@if (showCompanyName) { <header>{{ 'general.column.company-name' | translate }}</header> }
		@if (showSellerName) { <header>{{ 'sale.orders.seller-name' | translate }}</header> }
		<header defaultSort="ascending">{{ 'general.column.created' | translate }}</header>
		<header>{{ 'general.column.status' | translate }}</header>
		<header>{{ 'sales.orders.sales-type' | translate }}</header>
		<header align-right>{{ 'sale.orders.total-value' | translate }}</header>
		<row *listData="let order from orders"
			[groupBy]="groupBy(order)"
			[subGroupBy]="subGroupBy(order)"
			[brand]="order.salesTeamId | team:'brandId'"
			[disabled]="disabled(order) && refreshAvailable()"
			[select]="selectedOrder == order"
			(action)="displayOrder(order)">
			@if (showCompanyName) { <column>{{ order.company && order.company.name != '' ? order.company.name : ('general.na' | translate ) }}</column> }
			@if (showSellerName) { <column>{{ order.sellerId | user: 'name' }}</column> }
			<column [sortValue]="order.created">{{ order.created | customDate: 'shortDate' }}</column>
			<column>{{ ('sale.orders.status-' + salesService.getOrderStatus(order)) | translate }}</column>
			<column>{{ ('sale.orders.sales-type.' + salesService.getOrderSalesType(order)) | translate }}</column>
			<column align-right [sortValue]="salesService.getTotalPrice(order)">{{ salesService.getTotalPrice(order) | currency }}</column>
		</row>
	</list-view>
}
